<footer class="pe-5 mt-3 d-flex align-items-center justify-content-end">
  TotalEnergies - MultiProduct Studio 2024 ©
</footer>
